import { SESSION_STORAGE_KEYS } from "@/common/constants/storage";

export const SYNTAX_ERROR_ERROR_MESSAGE = "SyntaxError: Unexpected token '<'";
export const CHUNK_LOAD_ERROR_MESSAGE = "ChunkLoadError";

function setRecoveryUrl() {
  const pendingUrl = sessionStorage.getItem(SESSION_STORAGE_KEYS.PENDING_URL);
  if (pendingUrl) {
    sessionStorage.setItem(SESSION_STORAGE_KEYS.RECOVERY_URL, pendingUrl);
  }
}

function reloadApp() {
  window.location.reload();
}

window.addEventListener("error", (event: any) => {
  const message = event.message || "";

  if (message.includes(SYNTAX_ERROR_ERROR_MESSAGE)) {
    event.preventDefault();
    setRecoveryUrl();
    reloadApp();
  }
});

window.addEventListener("DOMContentLoaded", () => {
  const recoveryUrl = sessionStorage.getItem(SESSION_STORAGE_KEYS.RECOVERY_URL);

  if (recoveryUrl) {
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.RECOVERY_URL);
    window.location.replace(recoveryUrl);
  }
});
